
  import { css } from 'lit';
  export const styles = css`:host{--color: var(--ig-label-color, var(--ig-gray-800));--disabled-color: var(--ig-label-disabled-color, var(--ig-gray-300));--ig-theme: fluent;--ig-theme-variant: dark}`;
  